import LazyLoad from "vanilla-lazyload";

const lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy"
    // ... more custom settings?
});

document.addEventListener('afterBlitzInject', function (event) {
    lazyLoadInstance.update();
});